import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';

@Injectable({providedIn: 'root'})
export class OidcClientWrapper {
	private readonly ready;
	private oidcClient?: Promise<any>;

	constructor() {
		this.ready = import('../../../oidc-client/pkg')
			.then(oidc_client => {
				oidc_client.set_error_hook('oidc_client');
				this.oidcClient = oidc_client.OidcClient.new(environment.idp_url, environment.redirect_url, environment.client_id);
			})
			.catch(reason => console.error('error initializing WASM oidc_client: ', reason));
	}

	async generate_auth_url(): Promise<string> {
		await this.ready;
		if (this.oidcClient != null) {
			var acr = environment.minimum_acr
			return (await this.oidcClient).generate_auth_url([], `urn:qoa.eiam.admin.ch:names:tc:ac:classes:${acr}`);
		}
		throw new Error('WASM module not ready yet');
	}

	async get_token(auth_code: string, state: string): Promise<string> {
		await this.ready;
		if (this.oidcClient != null) {
			return (await this.oidcClient).get_token(auth_code, state);
		}
		throw new Error('WASM module not ready yet');
	}

	async logout_url(post_logout_url: string) : Promise<string> {
		await this.ready;
		if (this.oidcClient != null) {
			return (await this.oidcClient).logout_url(post_logout_url);
		}
		throw new Error('WASM module not ready yet');
	}

	async decode_token(id_token: string): Promise<string> {
		await this.ready;
		if (this.oidcClient != null) {
			return (await this.oidcClient).decode_token(id_token);
		}
		throw new Error('WASM module not ready yet');
	}
}
